/**
 * Paper texture preset data
 */

export interface PaperData {
  id: string;
  name: string;
  color: string;
  texture: string;
}

/** All paper presets */
export const PAPERS: PaperData[] = [
  { id: 'paper-smooth', name: 'Smooth', color: '#ffffff', texture: 'none' },
  { id: 'paper-matte', name: 'Matte', color: '#fafafa', texture: 'subtle' },
  { id: 'paper-canvas', name: 'Canvas', color: '#f5f0e6', texture: 'woven' },
  { id: 'paper-watercolor', name: 'Watercolor', color: '#fffef8', texture: 'rough' },
  { id: 'paper-rice', name: 'Rice Paper', color: '#f8f5e8', texture: 'fiber' },
  { id: 'paper-mulberry', name: 'Mulberry', color: '#f5f0e0', texture: 'fiber' },
  { id: 'paper-linen', name: 'Linen', color: '#f0ebe0', texture: 'woven' },
  { id: 'paper-antique', name: 'Antique', color: '#e8dcc8', texture: 'aged' },
  { id: 'paper-vellum', name: 'Vellum', color: '#f5efe5', texture: 'smooth' },
  { id: 'paper-handmade', name: 'Handmade', color: '#f0e8d8', texture: 'irregular' },
];

/** Lookup paper by ID */
export function getPaperPreset(paperId: string): PaperData | undefined {
  return PAPERS.find((p) => p.id === paperId);
}

/** Paper presets as a Record for quick lookup */
export const PAPER_PRESETS: Record<string, { color: string; texture: string }> = Object.fromEntries(
  PAPERS.map((p) => [p.id, { color: p.color, texture: p.texture }]),
);
